<head>

<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Agendar Atendimento</span>
  </div>
  <div class="row">
    <div class="col-md-6 col-lg-2">
      <label for="cpf">CPF</label><br />
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="params.cpf" id="cpf" />
    </div>
    <div class="col-md-6 col-lg-5">
      <label for="nome">Nome</label><br />
      <input type="text" class="form-control form-input-component" v-model="params.nome" id="nome" />
    </div>
    <div class="col-md-10 col-lg-4">
      <label>Especialidade</label><br />
      <select class="form-select form-input-component" v-model="params.especialidade">
        <option v-for="item in this.listaEspecialidades" :key="item.id" :value="item.especialidade.nome">
          {{ item.especialidade.nome }}
        </option>
      </select>
    </div>
    <div class="col-md-2 col-lg-1">
      <label> </label>
      <div class="col-sm-1 icon-button" style="padding: 12px">
        <div @click="pesquisar"><i class="fa fa-search"></i></div>
      </div>
    </div>
  </div>

  <br />

  <br />
  <a-table :dataSource="listaProfissional" :columns="columns" :key="id">
    <template #action="{ record }">
      <a @click="abrirAgenda(record.cpf)" title="Abrir Agenda"><i class="fa-solid fa-calendar-plus custom-icon"></i></a>
    </template>
    <!--
        <template #unidade="{ record }">
            <a-popconfirm
                v-if="dataSource.length"
                title="Confirma exclusão ?"
                @confirm="onDelete(record.key)">
                <a>Delete</a>
            </a-popconfirm>
        </template>
        -->
  </a-table>

  <!--
    <div style="height: max-content">
      <vue-cal
          class="vuecal--full-height-delete vuecal--blue-theme "
          locale="pt-br"
          hide-view-selector
          :time-from="6*60"
          :timeTo="20*60"
          :disable-views="['years','year','month','day']"
          :hide-weekdays="[]"
          :editable-events="{title: false, create : true, delete: true, resize: true, drag: false, drag: true}"
          :resizeX="true"
          :snapToTime="60"
          :dragToCreateEvent='true'
          :minDate="new Date()"
          :on-event-create="onEventCreate"

      />
    </div>

  -->
</template>

<script>
import { getProfissional } from '@/components/service/profissionalService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { getEspecialidades } from '@/components/service/especilidadeService';

export default {
  name: 'PageListarProfissionalAgendar',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      listaEspecialidades: [],
      listaProfissional: [],
      params: {
        cpfProfissional: undefined,
        nome: undefined,
        especialidade: undefined,
      },
      columns: [
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Especialidade',
          dataIndex: 'especialidade.nome',
          key: 'especialidade.id',
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    abrirAgenda(cpf) {
      this.$router.push({ path: '/agendar-atendimento', query: { cpf: cpf } });
    },
    atualizarTabela() {
      getProfissional(this.params).then((rs) => {
        this.listaProfissional = rs.data.profissionais;
      });
    },
    carregarDadosIniciais() {
      getEspecialidades()
        .then((r) => {
          this.listaEspecialidades = r.data;
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao carregar a lista de especialidades!');
        });
    },
    // eslint-disable-next-line no-unused-vars
    async pesquisar() {
      await getProfissional(this.params).then(() => {
        this.atualizarTabela();
      });
    },
  },
  created() {
    this.carregarDadosIniciais();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
